export const footer = () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, auto)',
    gridColumnGap: 16,
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '32px 30px',
});
